// D:\aifrai\FireBoiler\src\components\layout\Footer.jsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaTwitter, FaTelegram, FaLinkedin, FaYoutube, FaGithub } from 'react-icons/fa';

const Footer = () => {
  const navigate = useNavigate();
  
  // Get social media links from environment variables with fallbacks
  const socialLinks = {
    twitter: import.meta.env.VITE_LINKPAGE_TWITTER || 'https://x.com/AIFR_AI',
    telegram: import.meta.env.VITE_LINKPAGE_TELEGRAM || 'https://t.me/IAFranceRevolution_bot',
    linkedin: import.meta.env.VITE_LINKPAGE_LINKEDIN || 'https://www.linkedin.com/company/aifrancerevolution/',
    youtube: import.meta.env.VITE_LINKPAGE_YOUTUBE || 'https://www.youtube.com/@AIFranceRevolution',
    github: import.meta.env.VITE_LINKPAGE_GITHUB || 'https://github.com/IA-France-Revolution/'
  };
  
  return (
    <footer className="bg-gray-900 py-10 border-t border-gray-800">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between mb-10">
          {/* Logo */}
          <div className="flex items-center mb-6 md:mb-0">
            <div className="w-10 h-10 rounded-full bg-indigo-600 flex items-center justify-center mr-3">
              <span className="text-white font-bold text-lg">AI</span>
            </div>
            <div className="text-2xl font-bold text-white">AIFR<span className="text-indigo-400">.AI</span></div>
          </div>
          
          {/* Call to Action Button */}
          <button 
            onClick={() => navigate('/login')} 
            className="bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-3 rounded-lg font-semibold shadow-lg transition-all duration-300 transform hover:-translate-y-1"
          >
            Rejoindre le Mouvement
          </button>
        </div>
        
        {/* Links Grid */}
        <div className="grid md:grid-cols-4 gap-8 py-8 border-t border-b border-gray-800">
          <div>
            <h4 className="text-lg font-bold mb-4 text-white">À Propos</h4>
            <ul className="space-y-2">
              <li><button onClick={() => navigate('/about')} className="text-gray-400 hover:text-indigo-400 transition-colors">Notre Mission</button></li>
              <li><button onClick={() => navigate('/analysis-areas')} className="text-gray-400 hover:text-indigo-400 transition-colors">Nos Chantiers</button></li>
              <li><button onClick={() => navigate('/budget-analysis')} className="text-gray-400 hover:text-indigo-400 transition-colors">Analyses Budgétaires</button></li>
              <li><button onClick={() => navigate('/faq')} className="text-gray-400 hover:text-indigo-400 transition-colors">FAQ</button></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-bold mb-4 text-white">Participation</h4>
            <ul className="space-y-2">
              <li><button onClick={() => navigate('/projects')} className="text-gray-400 hover:text-indigo-400 transition-colors">Projets d'Analyse</button></li>
              <li><button onClick={() => navigate('/participation')} className="text-gray-400 hover:text-indigo-400 transition-colors">Comment Participer</button></li>
              <li><button onClick={() => navigate('/login')} className="text-gray-400 hover:text-indigo-400 transition-colors">Se Connecter</button></li>
              <li><button onClick={() => navigate('/dashboard')} className="text-gray-400 hover:text-indigo-400 transition-colors">Tableau de Bord</button></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-bold mb-4 text-white">Outils & Données</h4>
            <ul className="space-y-2">
              <li><button onClick={() => navigate('/subventions')} className="text-indigo-400 hover:text-white transition-colors font-semibold">Explorateur de Subventions</button></li>
              <li><button onClick={() => navigate('/research')} className="text-gray-400 hover:text-indigo-400 transition-colors">Recherche Avancée</button></li>
              <li><button onClick={() => navigate('/trainings')} className="text-gray-400 hover:text-indigo-400 transition-colors">Formations</button></li>
              <li><button onClick={() => navigate('/profile')} className="text-gray-400 hover:text-indigo-400 transition-colors">Profil Citoyen</button></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-bold mb-4 text-white">Communauté</h4>
            <ul className="space-y-3">
              <li>
                <div className="flex space-x-4">
                  {socialLinks.twitter && (
                    <a href={socialLinks.twitter} target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center text-gray-400 hover:bg-indigo-800 hover:text-white transition-all duration-300" aria-label="Twitter"><FaTwitter /></a>
                  )}
                  {socialLinks.telegram && (
                    <a href={socialLinks.telegram} target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center text-gray-400 hover:bg-indigo-800 hover:text-white transition-all duration-300" aria-label="Telegram"><FaTelegram /></a>
                  )}
                  {socialLinks.linkedin && (
                    <a href={socialLinks.linkedin} target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center text-gray-400 hover:bg-indigo-800 hover:text-white transition-all duration-300" aria-label="LinkedIn"><FaLinkedin /></a>
                  )}
                  {socialLinks.youtube && (
                    <a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center text-gray-400 hover:bg-indigo-800 hover:text-white transition-all duration-300" aria-label="YouTube"><FaYoutube /></a>
                  )}
                  {socialLinks.github && (
                    <a href={socialLinks.github} target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center text-gray-400 hover:bg-indigo-800 hover:text-white transition-all duration-300" aria-label="GitHub"><FaGithub /></a>
                  )}
                </div>
              </li>
              <li><button onClick={() => navigate('/contact')} className="text-gray-400 hover:text-indigo-400 transition-colors">Contact</button></li>
              <li><button onClick={() => navigate('/terms')} className="text-gray-400 hover:text-indigo-400 transition-colors">Conditions d'utilisation</button></li>
              <li><button onClick={() => navigate('/privacy')} className="text-gray-400 hover:text-indigo-400 transition-colors">Politique de confidentialité</button></li>
            </ul>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © {new Date().getFullYear()} Association IA France Révolution. Tous droits réservés.
          </p>
          <div className="flex items-center">
            <span className="text-gray-400 text-xs text-center md:text-right">C'est à nous, citoyens, de mobiliser l'intelligence artificielle pour la transparence et la réforme.</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;